<script lang="ts" setup>
import type { EpcGes } from '@@/shared/property/epc-ges';

const props = defineProps<{
  epcGes: EpcGes
  variant: `epc` | `ges`
}>();

const excessive = computed(() => {
  const isEpc = props.variant === `epc`;
  const isExcessive = props.epcGes[props.variant].status === `available-excessive`;
  return {
    logo: isEpc && isExcessive,
    text: isExcessive,
  };
});
</script>

<template>
  <aside
    class="border border-2 bg-white rounded-lg p-s flex flex-col gap-s"
    :class="{
      [`border-${variant}-${epcGes[props.variant].class}`]: true,
    }"
  >
    <div class="flex justify-between">
      <IadTitle
        variant="small-semibold"
        :text="epcGes[props.variant].class"
      />
      <Icon
        v-if="excessive.logo"
        class="size-[30px] text-error"
        name="iad-icon:epc-excessive"
      />
    </div>

    <b
      v-if="excessive.text"
      class="text-error text-xs font-semibold"
      v-text="$t(`property.epc_ges.${variant}.emission.excessive`)"
    />

    <p
      v-if="variant === `epc`"
      class="flex flex-col gap-2xs"
    >
      <span
        class="text-xs"
        v-text="$t(`property.epc_ges.preview.epc.title`)"
      />
      <span
        class="text-base font-semibold"
        v-text="$t(`property.epc_ges.epc.consumption`, { consumption: epcGes.epc.consumption })"
      />
      <template v-if="epcGes.finalEnergyPerformanceConsumption">
        <span
          class="text-xs"
          v-text="$t(`property.epc_ges.preview.final_energy.title`)"
        />
        <span
          class="text-base font-semibold"
          v-text="$t(`property.epc_ges.epc.consumption`, { consumption: epcGes.finalEnergyPerformanceConsumption })"
        />
      </template>
    </p>

    <p class="grid grid-rows gap-2xs">
      <span
        class="text-xs"
        v-text="$t(`property.epc_ges.preview.ges.title`)"
      />
      <span
        class="after:content-['*'] text-base font-semibold"
        v-text="$t(`property.epc_ges.ges.consumption`, { consumption: epcGes.ges.consumption })"
      />
    </p>
  </aside>
</template>
